import routes from '@modules/subproperty/subproperty-routes';
import store from '@modules/subproperty/subproperty-store';

export default {
  routes,
  store,
};
